/** Lookup verilerini oturum boyunca localStorage + sessionStorage'da senkron tutar. */
export function persistLookupCache(key, value) {
    const json = JSON.stringify(value ?? null);
    try {
        localStorage.setItem(key, json);
        sessionStorage.setItem(key, json);
    } catch {
        /* ignore quota / private mode */
    }
}

export function readLookupCache(key) {
    try {
        const raw = localStorage.getItem(key) ?? sessionStorage.getItem(key);
        if (!raw) return null;
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

export function dispatchLookupUpdated(eventName, detail) {
    try {
        window.dispatchEvent(new CustomEvent(eventName, { detail }));
    } catch {
        /* ignore */
    }
}
